import PropTypes from 'prop-types';
import { Station } from './station';
import { ReviewRatingType } from './rating-types';

export const MemberType = PropTypes.shape({
  username: PropTypes.string,
  avatar_url: PropTypes.string,
});

export const AuthorInfoType = PropTypes.shape({
  autthor_name: PropTypes.string,
  organization_id: PropTypes.number,
  user_id: PropTypes.number,
});

export const RepliesType = PropTypes.shape({
  author_info: AuthorInfoType,
  brand_id: PropTypes.number,
  create_date: PropTypes.string,
  text: PropTypes.string,
});

export const StationReviewType = PropTypes.shape({
  agree_total: PropTypes.number,
  brand_logo_url: PropTypes.string,
  category_tags: PropTypes.arrayOf(PropTypes.string),
  create_date: PropTypes.string,
  id: PropTypes.number,
  is_reportable: PropTypes.bool,
  is_visible: PropTypes.bool,
  member: MemberType,
  ratings: PropTypes.arrayOf(ReviewRatingType),
  replies: PropTypes.arrayOf(RepliesType),
  reply_requested: PropTypes.bool,
  sentiment: PropTypes.string,
  starred: PropTypes.bool,
  station: Station,
  station_id: PropTypes.number,
  text: PropTypes.string,
});

export const StationReviewsObjectType = PropTypes.shape({
  meta: {
    totalReviews: PropTypes.number,
  },
  reviews: PropTypes.arrayOf(StationReviewType),
});
